let lastIdentityKey = null;

const getLogRocket = () => {
  if (typeof window === "undefined") return null;
  return window.LogRocket || null;
};

const pickFirst = (...values) =>
  values.find((value) => value !== null && value !== undefined && String(value).trim() !== "");

const getUserFromSession = (sessionOrUser) => {
  if (!sessionOrUser || typeof sessionOrUser !== "object") return null;
  if (sessionOrUser?.data && typeof sessionOrUser.data === "object") {
    return sessionOrUser.data;
  }
  return sessionOrUser;
};

const buildIdentityPayload = (sessionOrUser) => {
  const user = getUserFromSession(sessionOrUser);
  if (!user) return null;

  const id = pickFirst(
    user?.id,
    user?.restaurantid,
    user?.restaurant_id,
    user?.user_id,
    user?.mobile_number,
    user?.mobile
  );

  if (id === null || id === undefined) return null;

  const traits = {
    name: pickFirst(user?.name, user?.restaurant_name),
    username: pickFirst(
      user?.restaurant_name,
      user?.shop_name,
      user?.username,
      user?.email,
      user?.mobile_number,
      user?.mobile
    ),
    mobile_number: pickFirst(user?.mobile_number, user?.mobile, user?.phone),
    role: pickFirst(user?.role, user?.user_role),
    restaurant_name: pickFirst(user?.restaurant_name, user?.shop_name),
    restaurant_id: pickFirst(user?.restaurantid, user?.restaurant_id),
  };

  Object.keys(traits).forEach((key) => {
    if (traits[key] === null || traits[key] === undefined || traits[key] === "") {
      delete traits[key];
    }
  });

  return {
    id: String(id),
    traits,
  };
};

export const identifyLogRocketUser = (sessionOrUser) => {
  const logRocket = getLogRocket();
  if (!logRocket?.identify) return false;

  const payload = buildIdentityPayload(sessionOrUser);
  if (!payload) return false;

  const nextIdentityKey = JSON.stringify([payload.id, payload.traits]);
  if (nextIdentityKey === lastIdentityKey) return true;

  logRocket.identify(payload.id, payload.traits);
  lastIdentityKey = nextIdentityKey;
  return true;
};

export const resetLogRocketSession = () => {
  const logRocket = getLogRocket();
  if (logRocket?.reset) {
    logRocket.reset();
  }
  lastIdentityKey = null;
};

export const syncLogRocketSession = (sessionOrUser) => {
  const user = getUserFromSession(sessionOrUser);
  if (!user || !Object.keys(user).length) {
    resetLogRocketSession();
    return false;
  }
  return identifyLogRocketUser(sessionOrUser);
};
